/** @format */

import template from './gb-radio-button.html';
import './gb-radio-button.scss';

export const GbRadioButtonComponent = {
    template,
    transclude: true,
    require: {
        ngModel: '^^',
    },
    bindings: {
        icon: '@',
        value: '@',
    },
    controller: class GbRadioButtonComponent {
        constructor($element) {
            'ngInject';

            this.$element = $element;
        }

        isSelected() {
            return !!this.ngModel && this.ngModel.$viewValue === this.value;
        }

        $onInit() {
            this.$element.attr('role', 'radio');

            this.$element.on('click', () => {
                this.ngModel.$setViewValue(this.value);
            });
        }
    },
};
